import React from "react";
import AnonymousStatusBar from "./AnonymousStatusBar/AnonymousStatusBar";
import LoggedInStatusBar from "./LoggedInStatusBar/LoggedInStatusBar";

export type Route = "ACCOUNT" | "ACCOUNT_OVERVIEW";

export interface StatusBarAnonymousProps {
    readonly anonymous: true;
    readonly balance: number;
    readonly bonusValue: string;
    readonly vouchersEnabled: boolean;
    readonly currency: string;
    readonly onPrintVoucher: () => void;
}
export interface StatusBarLoggedInProps {
    readonly anonymous: false;
    readonly balance: number;
    readonly bonusValue: string;
    readonly foreignLogin: boolean;
    readonly hasOptInCheckboxChecked: boolean;
    readonly currency: string;
    readonly userApproved: boolean;
    readonly userLogin: string;
    readonly validForeignUser: boolean;
    readonly onLogout: () => void;
}

export default function StatusBar(
    props: StatusBarAnonymousProps | StatusBarLoggedInProps
) {
    if (props.anonymous) {
        return <AnonymousStatusBar {...props} />;
    } else {
        return <LoggedInStatusBar {...(props as StatusBarLoggedInProps)} />;
    }
}
